import i18n from "@/plugins/i18n";

function getAnnouncementColumns(handlers) {
  return getColumns(handlers, announcementColumns);
}

function getMemberNewsColumns(handlers) {
  return getColumns(handlers, memberNewsColumns);
}


function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const announcementColumns = [
  {
    text: i18n.t("label.post_title"),
    value: "title",
    sortBy: "title",
    type: "text",
  },
  {
    text: i18n.t("label.post_created_at"),
    value: "created_at",
    sortBy: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "description",
        buttonClass: "md-primary",
        key: 'description',
        handler: null,
      },
    ],
  },
];

const memberNewsColumns = [
  {
    text: i18n.t("label.post_title"),
    value: "title",
    sortBy: "title",
    type: "text",
  },
  {
    text: i18n.t("label.post_writer"),
    value: 'member',
    subField: 'name',
    sortBy: "member_name",
    type: "text",
  },
  {
    text: i18n.t("label.post_created_at"),
    value: "created_at",
    sortBy: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "description",
        buttonClass: "md-primary",
        key: "description",
        handler: null,
      },
    ],
  },
];

export { getAnnouncementColumns, getMemberNewsColumns };
